import { Table as UsersTable } from '@/components/company_user/table'

export const Users = () => {
  return (
    <>
      <UsersTable pageSize={20} updateable />
    </>
  )
}
